module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Testimoni',
          to: {
            path: '/testimoni'
          },
          exact: true,
        },
        {
          text: !_vm.$route.query.id ?
            'Tambah Testimoni' :
            'Ubah Testimoni',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Testimoni" : "Ubah Testimoni") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticStyle: {}
  }, [_c('v-card', {
    staticClass: "d-flex",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    key: _vm.keyimg,
    attrs: {
      "src": _vm.url ?
        _vm.url :
        require('@/assets/img/unavailable.png')
    }
  })])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-btn', {
    staticClass: "pa-0 font-weight-bold dark--text",
    attrs: {
      "block": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_vm._v("\n                            Upload *\n                        ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Rasio Foto 1:1 (HD)\n                    ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [(!_vm.$route.query.id) ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Email\n                                ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "placeholder": "Email User",
      "maxLength": "50",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: (_vm.emailInput),
      callback: function($$v) {
        _vm.emailInput = $$v
      },
      expression: "emailInput"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.query.id) ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Email\n                                ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "placeholder": "Email User",
      "maxLength": "50",
      "persistent-hint": "",
      "outlined": "",
      "disabled": ""
    },
    model: {
      value: (_vm.emailInput),
      callback: function($$v) {
        _vm.emailInput = $$v
      },
      expression: "emailInput"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Nama\n                                ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "placeholder": "Nama User",
      "maxLength": "50",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.student_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "student_name", $$v)
      },
      expression: "data.student_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Jenjang\n                                ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "mandatory": ""
    },
    on: {
      "change": function($event) {
        _vm.data.grade = []
      }
    },
    model: {
      value: (_vm.data.level),
      callback: function($$v) {
        _vm.$set(_vm.data, "level", $$v)
      },
      expression: "data.level"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SD",
      "value": "SD",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SMP",
      "value": "SMP",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SMA",
      "value": "SMA",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Kelas\n                                ")]), _vm._v(" "), (_vm.data.level === 'SD') ? _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.grade),
      callback: function($$v) {
        _vm.$set(_vm.data, "grade", $$v)
      },
      expression: "data.grade"
    }
  }, _vm._l((6), function(i) {
    return _c('v-radio', {
      key: i,
      staticClass: "jenjang-selection",
      attrs: {
        "label": '' + i,
        "value": i,
        "active-class": "act-radio-btn"
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.level === 'SMP') ? _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.grade),
      callback: function($$v) {
        _vm.$set(_vm.data, "grade", $$v)
      },
      expression: "data.grade"
    }
  }, _vm._l((3), function(i) {
    return _c('v-radio', {
      key: i,
      staticClass: "jenjang-selection",
      attrs: {
        "label": '' + (i + 6),
        "value": i + 6,
        "active-class": "act-radio-btn"
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.level === 'SMA') ? _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.grade),
      callback: function($$v) {
        _vm.$set(_vm.data, "grade", $$v)
      },
      expression: "data.grade"
    }
  }, _vm._l((3), function(i) {
    return _c('v-radio', {
      key: i,
      staticClass: "jenjang-selection",
      attrs: {
        "label": '' + (i + 9),
        "value": i + 9,
        "active-class": "act-radio-btn"
      }
    })
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Rating\n                                ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.rating),
      callback: function($$v) {
        _vm.$set(_vm.data, "rating", $$v)
      },
      expression: "data.rating"
    }
  }, _vm._l((5), function(i) {
    return _c('v-radio', {
      key: i,
      staticClass: "jenjang-selection",
      attrs: {
        "label": '' + i,
        "value": i,
        "active-class": "act-radio-btn"
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Nama Paket\n                                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pb-2",
    attrs: {
      "items": _vm.packagesList,
      "item-text": "package_name",
      "item-value": "package_id",
      "placeholder": "Pilih paket",
      "outlined": ""
    },
    model: {
      value: (_vm.data.package_id),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_id", $$v)
      },
      expression: "data.package_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Deskripsi Testimoni\n                                ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Deskripsi testimoni",
      "maxlength": 500,
      "counter": 500,
      "outlined": ""
    },
    model: {
      value: (_vm.data.testimoni),
      callback: function($$v) {
        _vm.$set(_vm.data, "testimoni", $$v)
      },
      expression: "data.testimoni"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Is Show\n                                ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "label": "Is Show",
      "false-value": false,
      "true-value": true,
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_show),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_show", $$v)
      },
      expression: "data.is_show"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-2 mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/testimoni'
        })
      }
    }
  }, [_vm._v("\n                                Batal\n                            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("\n                                Simpan\n                            ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e355a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/TestimoniForm.vue
// module id = 2030
// module chunks = 1